var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-3 col-md-6 "},[_c('dashboard-stats-card',{attrs:{"sub-title":_vm.result,"icon":"ni ni-app","title":"Schedule Call","type":"gradient-red","not-loading":!_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }